import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Ability } from "@casl/ability";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary"; // Import the Error Boundary
import "./index.css";

// Material Dashboard 2 PRO React Context Provider
import { MaterialUIControllerProvider, AuthContextProvider, ExperimentProvider } from "./context";
import { AbilityContext } from "./Can";

const container = document.getElementById("root");
const root = createRoot(container);
const ability = new Ability();

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled rejection:", event.reason);
});

window.onerror = function (message, source, lineno, colno, error) {
  console.log("An error occurred:", message);
  return true; // Prevent the firing of the default event handler
};

root.render(
  <AbilityContext.Provider value={ability}>
    <BrowserRouter>
      <AuthContextProvider>
        <ExperimentProvider>
          <MaterialUIControllerProvider>
            <App ability={ability} />
          </MaterialUIControllerProvider>
        </ExperimentProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </AbilityContext.Provider>
);